import { compose } from 'redux';
import { makeGraphQLRequest } from 'graphql/makeGraphQLRequest';
import { GET_SIMPLR_EXPERT_BY_ID_QUERY } from './ownExpertLoader.gql';
import { processSimplrExpert } from 'util/dataObjectToStoreObject';
import subscribeToLiveQuery from 'liveQueryMiddleware/subscribeToLiveQuery';
import {
  SIMPLR_EXPERT_CREATE_SUBSCRIPTION,
  SIMPLR_EXPERT_UPDATE_SUBSCRIPTION,
  SIMPLR_EXPERT_ENTER_SUBSCRIPTION,
} from './ownExpertLoaderSubscriptions.gql';

export const getExpertById = async (id) => {
  const simplrExpert = await makeGraphQLRequest(
    GET_SIMPLR_EXPERT_BY_ID_QUERY,
    { simplrExpertId: id },
    'simplrExpertGet'
  );

  return simplrExpert;
};

const initialLoad = async ({ updateExpert, simplrExpertId }) => {
  if (!simplrExpertId) {
    throw new Error('simplrExprtId required');
  }

  const simplrExpert = await getExpertById(simplrExpertId);

  updateExpert(processSimplrExpert(simplrExpert));
};

const subscribe = async ({ updateExpert, simplrExpertId }) => {
  if (!simplrExpertId) {
    throw new Error('simplrExprtId required');
  }

  const variables = {
    filter: {
      id: {
        eq: simplrExpertId,
      },
    },
  };

  const handleOnEventReceived = compose(updateExpert, processSimplrExpert);

  const createSubscription = subscribeToLiveQuery(
    SIMPLR_EXPERT_CREATE_SUBSCRIPTION,
    variables,
    'onCreateSimplrExpert',
    handleOnEventReceived
  );

  const updateSubscription = subscribeToLiveQuery(
    SIMPLR_EXPERT_UPDATE_SUBSCRIPTION,
    variables,
    'onUpdateSimplrExpert',
    handleOnEventReceived
  );

  const enterSubscription = subscribeToLiveQuery(
    SIMPLR_EXPERT_ENTER_SUBSCRIPTION,
    variables,
    'onEnterSimplrExpert',
    handleOnEventReceived
  );

  return [createSubscription, updateSubscription, enterSubscription];
};

const unsubscribe = (subscriptions) => {
  if (subscriptions && Array.isArray(subscriptions)) {
    subscriptions.forEach((s) => s.unsubscribe());
  }
};

export { initialLoad, subscribe, unsubscribe };
